import { useQuery } from '@tanstack/react-query';
import { queries } from '../queries';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../types';
import type { IGetModemsParams } from '../apis/modem/types';
import { handleError } from '../../components/ui/err/handleError';

export default function useGetModems(params: IGetModemsParams) {
  return useQuery({
    ...queries.modems.modemList(params),
    select: (data) => data?.data,
    keepPreviousData: true,
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
